'use strict';
angular.module('cvsApp').factory('generateReportModel',['commonModel', function(CM) {	
	
	var generateReportModel = function(){
		var self = this;
		this.apiResponse = {};
		
		this.setReportResponse = function(data){			
			
		}
	
		this.getReportResponse = function(){
			CM.getResponse();
		}
	
	}
	
	return new generateReportModel();
}]);